/**
 * «История состояний» запуска — внутренние состояния оркестратора auto-ads
 * (`state`, не `displayStatus`) и причины переходов словами. Незнакомое —
 * как есть: новый код должен быть виден, а не пропасть.
 */
const LAUNCH_STATE_RU = {
    draft: 'черновик',
    validated: 'проверен',
    queued: 'в очереди',
    executing: 'создаётся',
    ready: 'создан',
    paused_ready: 'создан, на паузе',
    activating: 'включается',
    active: 'включён',
    needs_attention: 'требует внимания',
    failed: 'ошибка',
    cancelled: 'отменён',
    rolling_back: 'откат',
    rolled_back: 'удалён',
};
const TRANSITION_REASON_RU = {
    activate: 'включение',
    activated: 'включён',
    'all steps done': 'все шаги выполнены',
    'batch (enqueue)': 'поставлен пачкой в очередь',
    drift: 'подмена настроек в Meta',
    rollback: 'откат',
    'rollback done': 'откат завершён',
    'validate ok': 'проверка пройдена',
    worker: 'исполнитель',
    'verify-unavailable': 'сверка недоступна',
    'pause-failed': 'пауза не удалась',
    manual: 'вручную',
    late: 'опоздал к старту',
    cancelled: 'отменён',
    'start-too-close': 'старт слишком близко',
    'verify-errors': 'расхождения при сверке',
    'created active with a future start, verify clean': 'создан включённым с датой старта, сверка чистая',
    'created, start too close — paused, waits for a human': 'старт слишком близко — на паузе, ждёт человека',
    'created active, verify errors — paused': 'создан включённым, расхождения — поставлен на паузу',
    'created active, cancelled — paused': 'создан включённым, пачку отменили — на паузе',
    'created active, verify errors — PAUSED FAILED': 'создан включённым, расхождения — пауза не удалась',
};
export function launchStateRu(state) {
    if (state == null)
        return '—';
    return LAUNCH_STATE_RU[state] ?? state;
}
export function transitionReasonRu(reason) {
    return TRANSITION_REASON_RU[reason] ?? reason;
}
//# sourceMappingURL=state-history.js.map